import FormatterV1 from './FormatterV1';
import FinanceWithChevron from '../../FinanceWithChevron';
import React from 'react';

export const MemberPriceContainerV1 = ({
	memberPrice,
	nowPrice,
	was,
	save,
	ProductMemberPriceFinanceQuote,
	inStock,
	Code,
	ColourId,
	State,
	FinancePromotions,
	productTitle,
	useOldPricePod,
	upfrontPaymentAmount,
}) => {
	const memberSaving = nowPrice - memberPrice;
	return (
		<>
			<div
				className="memberprice-container px-3 py-2 rounded relative overflow-hidden md:mt-2 z-10 relative"
				data-testid="price-member">
				<div className="flex flex-col text-title lg:text-xs items-baseline">
					<span className="member-price-title text-sm z-10 text-cta-mainhover lg:leading-snug xl:leading-snug mb-1">
						AO member price
					</span>
					<div className="flex items-baseline">
						<span className="member-price text-lg md:text-lg lg:text-xl lg:text-sm 2xl:block text-cta-mainhover leading-none xl:leading-none">
							{FormatterV1.format(memberPrice)}
						</span>
						<div className="text-membersave text-caption font-bold text-deals ml-1">
							{was > 0 && save > 0
								? `${FormatterV1.format(memberSaving)}\u00A0Extra\u00A0Saving`
								: `Save ${FormatterV1.format(memberSaving)}`}
						</div>
					</div>
				</div>
				{ProductMemberPriceFinanceQuote && inStock ? (
					<>
						<FinanceWithChevron
							NewDayFinanceQuote={ProductMemberPriceFinanceQuote}
							productTitle={productTitle}
							MemberPrice={memberPrice}
							NowPrice={nowPrice}
							Code={Code}
							ColourId={ColourId}
							financePromotions={FinancePromotions}
							State={State}
							useOldPricePod={useOldPricePod}
							upfrontPaymentAmount={upfrontPaymentAmount}
						/>
					</>
				) : null}
			</div>
		</>
	);
};
